import { render, staticRenderFns } from "./CompletePage.vue?vue&type=template&id=b5225926&scoped=true"
import script from "./CompletePage.vue?vue&type=script&lang=js"
export * from "./CompletePage.vue?vue&type=script&lang=js"
import style0 from "./CompletePage.vue?vue&type=style&index=0&id=b5225926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5225926",
  null
  
)

export default component.exports